/**
 * Phase 25 Plan 25-03 — frontend transport for the mention-candidates
 * picker. Endpoint contract is locked by Plan 25-01:
 *
 *   GET /api/projects/:projectId/mention-candidates?q={partial}
 *   →   { data: MentionCandidate[] }   (server caps at 8 rows)
 *
 * The MentionCandidate row shape mirrors the backend's
 * `mentionCandidatesService.MentionCandidate` exactly so the picker can
 * consume it without an extra adapter layer.
 */
import { apiGet } from './client';

export interface MentionCandidate {
  id: number;
  kind: 'user' | 'external_user';
  firstName: string | null;
  lastName: string | null;
  email: string;
}

interface MentionCandidatesResponse {
  data: MentionCandidate[];
}

/**
 * GET /api/projects/:projectId/mention-candidates?q={q}
 *
 * The `q` filter is trimmed and URL-encoded; an empty/whitespace-only
 * `q` is sent as no querystring (matches Plan 25-01's empty-q semantics:
 * server returns the alphabetical 8 most-relevant rows).
 */
export async function fetchMentionCandidates(
  projectId: number,
  q: string,
): Promise<MentionCandidate[]> {
  const trimmed = q.trim();
  const qs = trimmed ? `?q=${encodeURIComponent(trimmed)}` : '';
  const res = await apiGet<MentionCandidatesResponse>(
    `/projects/${projectId}/mention-candidates${qs}`,
  );
  return res.data;
}
